<div *ngIf="showFilter" fxLayout="row" fxLayoutAlign="top left">
	<app-capacity-search-filter
		(filteredList)="
			updateFilteredList($event);
			setCarrierFilter();
			initialiseUpgradeProMsg();
			updatePannelHeader()
		"
		(isRequestInProgress)="isRequestInProgress.emit($event)"
		(noNetworkCarriersMsg)="noNetworkCarriersMsg = $event"
		(isSearchRefined)="getSearchRefined($event)"
		[capacitySearchResults]="capacitySearchResults"
		[customerCarrierMatched]="isCustomerCarrierMatched"
		[emailByTruckIds]="emailByTruckIds"
		[inNetworkCarrierCountForSearch]="inNetworkCarrierCountForSearch"
		[lanePricing]="lanePricing"
		[matchedCarriers]="matchedCarriers"
		[matchedCarrierIds]="matchedCarrierIds"
		[searchTruckForm]="searchTruckForm"
		[truckLaneSearchId]="truckLaneSearchId"
		[truckSearchId]="truckSearchId"
		[truckSearchIds]="truckSearchIds"
		[truckSearchResultCopy]="truckSearchResultCopy"
		[isCityMissing]="isCityMissing"
		fxFlex="100"
	>
	</app-capacity-search-filter>
</div>

<div
	*ngIf="showFilter && (utilService.isAccountTypeBroker() || utilService.isAccountTypeShipper())"
	class="m-t-1"
	fxLayout="row"
>
	<div fxFlex>
		<app-deadhead-sliders
			(sliderChange)="sliderChange.emit()"
			[destinationSliderDisabled]="searchTruckForm && IS_EMPTY(searchTruckForm?.destination?.city)"
			[isLoadingSearchResults]="isTruckSearch"
			[lanePricing]="lanePricing"
			[originSliderDisabled]="searchTruckForm && IS_EMPTY(searchTruckForm?.origin?.city)"
			[showRecentTransactionsCard]="pricingComponent?.showRecentTransactionsCard"
		></app-deadhead-sliders>
	</div>
	<div fxFlex="20">
		<app-power-units-filter
			(trucksCountChange)="trucksCountChange.emit($event)"
			[isLoadingSearchResults]="isTruckSearch"
			[searchTruckForm]="searchTruckForm"
		>
		</app-power-units-filter>
	</div>
	<div fxFlex="20">
		<app-frequency-filter
			(sliderChange)="sliderChange.emit()"
			[isLoadingSearchResults]="isTruckSearch"
			[searchTruckForm]="searchTruckForm"
		>
		</app-frequency-filter>
	</div>
</div>

<div *ngIf="!utilService.isNullOrUndefined(truckSearchResult); else skeletonLoader">
	<div class="font-size-12 label-text-light my-2" fxLayout="row" *ngIf="showTotalCount">
		<div *ngIf="showDragCarrierText" fxFlex>
			{{ dragCarrierText }}
		</div>
		<div fxFlex fxLayoutAlign="{{ showDragCarrierText ? 'end center' : 'start start' }}">
			{{ totalSearchLength }} Matching {{ totalSearchLength > 1 ? 'Carriers' : 'Carrier' }}
		</div>
	</div>

	<div fxLayout="row" fxLayoutAlign="top left">
		<mat-accordion fxFlex="100">
			<mat-expansion-panel
				(closed)="isCapacitySearch ? matchClosed() : null"
				(dragend)="dragend()"
				(dragstart)="drag($event, search)"
				(opened)="setStep(i)"
				*ngFor="let search of capacitySearchResults | slice: lowValue : highValue; let i = index"
				[disabled]="isShiftKeyPressed"
				[dragData]="search"
				dragImage="assets/icons/drag_indicator.svg"
				[expanded]="step == i"
				[hideToggle]="true"
				[ngClass]="{
					'mat-elevation-z4 primary-border':
						isCapacitySearch && selectedMatch?.carrierId == search.carrierId,
					'panel-selected mat-elevation-z4':
						isMultiselectEnabled && selectedCarrierIds.indexOf(search.carrierId) > -1,
					'm-t-1': i > 0
				}"
				class="custom-panel mat-elevation-z1"
				dragTransitClass="no-border"
				draggable
				id="{{ search.carrierId }}"
			>
				<mat-expansion-panel-header
					(click)="isMultiselectEnabled ? panelClicked(search, $event) : null"
					(keydown.arrowdown)="$event.stopImmediatePropagation()"
					(keydown.arrowup)="$event.stopImmediatePropagation()"
					(keydown.enter)="$event.stopImmediatePropagation()"
					[collapsedHeight]="'125px'"
					[expandedHeight]="'125px'"
				>
					<app-pannel-header
						#pannelHeaders
						(loadMoreProjects)="loadMoreProjects.emit()"
						(navigateToProjectsTab)="navigateToProjectsTab.emit()"
						(notesDialogClosed)="afterNotesDialogClose($event)"
						(openLaneDetails)="openLaneDetails.emit($event)"
						(panelClicked)="panelClicked($event.search, $event.mouseEvent)"
						(projectToggled)="updateTruckSearchResultsCopy($event)"
						(reloadProjectsList)="reloadProjectsList.emit()"
						[accountCarrierLanes]="accountCarrierLanes"
						[addCarriersToProject]="addCarriersToProject"
						[allProjectsList]="allProjectsList"
						[carrierAllProjects]="
							utilService.isNullOrUndefined(carrierAllProjectsMap[search.carrierId])
								? []
								: carrierAllProjectsMap[search.carrierId]
						"
						[carrierToProjectsMap]="
							utilService.isNullOrUndefined(carrierProjectMap[search.carrierId])
								? []
								: carrierProjectMap[search.carrierId]
						"
						[filters]="filters"
						[isLoadingAccountCarrierLanes]="isLoadingAccountCarrierLanes"
						[isLoadingProjectsList]="isLoadingProjectsList"
						[isMultiselectEnabled]="isMultiselectEnabled"
						[projectsNextPage]="projectsNextPage"
						[searchResult]="search"
						[searchTruckForm]="searchTruckForm"
						[selectedCarrierIds]="selectedCarrierIds"
						[showFMCSA]="step == i && showFMCSA"
						[totalNumberOfProjects]="totalNumberOfProjects"
						[truckLaneSearchId]="truckLaneSearchId"
						[userCarrierMapList]="userCarrierMapList"
						[userCarrierMap]="userCarrierMap"
						[usersList]="usersList"
						[customerCarrier]="search.customerCarrier"
						[isCarrierVettingIntegrationEnabled]="isCarrierVettingIntegrationEnabled"
						[isCarrierOnboarded]="carrierVettingService.isCarrierOnboarded(search.carrierId)"
						style="width: 100%"
					>
					</app-pannel-header>
				</mat-expansion-panel-header>

				<app-pannel-body
					(customerCarrierUpdated)="search.customerCarrier = $event; setCustomerCarrierMatched()"
					(emitUserResponse)="submitUserFeedback($event); this.step = this.step == i ? null : ''"
					(feedbackClicked)="feedbackClicked.emit($event)"
					(openLaneDetails)="openLaneDetails.emit($event)"
					(recentFeedbackList)="recentFeedbackList.emit($event)"
					*ngIf="step == i"
					[capacitySearch]="search"
					[editPrimaryContact]="false"
					[searchTruckForm]="searchTruckForm"
				></app-pannel-body>
			</mat-expansion-panel>
		</mat-accordion>
	</div>

	<mat-paginator
		(page)="getPaginatorData($event)"
		*ngIf="totalSearchLength > PAGE_SIZE"
		[length]="totalSearchLength"
		[pageSizeOptions]="[PAGE_SIZE]"
		class="mat-elevation-z1 m-t-1"
	>
	</mat-paginator>
</div>

<div
	*ngIf="truckSearchResult != null && showUpgradePlanCard()"
	class="m-t-1"
	fxLayout="row"
	fxLayoutAlign="top left"
>
	<mat-card fxFlex="100">
		<mat-card-content class="primary-text font-size-16" fxLayoutAlign="center center">
			<div [innerHTML]="UPGRADE_MSG"></div>
		</mat-card-content>
	</mat-card>
</div>

<div
	*ngIf="truckSearchResult != null && IS_NOT_EMPTY(noNetworkCarriersMsg)"
	class="m-t-1"
	fxLayout="row"
	fxLayoutAlign="top left"
>
	<mat-card fxFlex="100">
		<mat-card-content class="primary-text font-size-16" fxLayoutAlign="center center">
			<div [innerHTML]="noNetworkCarriersMsg"></div>
		</mat-card-content>
	</mat-card>
</div>

<div *ngIf="showRequestLanes()" class="m-t-1" fxLayout="row" fxLayoutAlign="end center">
	<button (click)="requestLanes()" color="primary" mat-raised-button>Request More Lanes</button>
</div>

<div *ngIf="!isTruckSearch && !showSearchFilter()">
	<div class="full-width" fxLayout="row">
		<mat-card class="m-t-1" fxFlex>
			<mat-card-content fxLayoutAlign="center center">
				<h5>
					We did not find any capacity for your lane. Please try increasing the deadhead for more
					options.
				</h5>
			</mat-card-content>
		</mat-card>
	</div>
</div>

<ng-template #skeletonLoader>
	<div>
		<app-skeleton-loader [SHOW_PANEL]="true"></app-skeleton-loader>
	</div>
</ng-template>
